import { UiColors } from "../../../../config/ui/colors";

export const WEEE_FLOW_IN_THE_HOME_APPLIANCE_SECTOR_CHART_DATA_KEYS = [
	{
		name: "collected",
		translation: "Total collected",
		color: UiColors.charts.primary,
	},
	{
		name: "treatment",
		translation: "Total treatment",
		color: UiColors.charts.secondary,
	},
	{
		name: "recovered",
		translation: "Total recovered",
		color: UiColors.charts.tertiary,
	},
	{
		name: "reused",
		translation: "Total reused and recycled",
		color: UiColors.charts.quaternary,
	},
];
